import {Injectable} from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({ providedIn: 'root' })
export class CryptoService {

  

  key = 'secret key 123';
constructor() { }

set(value) {
let ciphertext;
if (typeof value === 'object') {
ciphertext = CryptoJS.AES.encrypt(JSON.stringify(value), this.key);
} else {
ciphertext = CryptoJS.AES.encrypt(value, this.key);
}
return ciphertext;
}

get(ciphertext) {
const bytes = CryptoJS.AES.decrypt(ciphertext.toString(), this.key);
const plaintext = bytes.toString(CryptoJS.enc.Utf8);
return plaintext;
}
}
